
import { defineComponent, ref, computed, reactive, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from '@/store'

export default defineComponent({
  name: 'OrgListView',
  setup() {
    const store = useStore()
    const router = useRouter()
    const loading = ref(false)
    const error = ref<string | null>(null)
    const successMsg = ref<string | null>(null)

    const showCreate = ref(false)
    const saving = ref(false)
    const formError = ref<string | null>(null)
    const form = reactive({ orgName: '', adminName: '', adminEmail: '' })

    const organisations = computed(() => store.getters['superAdmin/getAllOrganisations'])

    async function load() {
      loading.value = true
      error.value = null
      try {
        await store.dispatch('superAdmin/LOAD_ALL_ORGANISATIONS', { force: true })
      } catch (e: any) {
        error.value = 'Organisationen konnten nicht geladen werden.'
      } finally {
        loading.value = false
      }
    }

    function openCreate() {
      form.orgName = ''
      form.adminName = ''
      form.adminEmail = ''
      formError.value = null
      showCreate.value = true
    }

    function closeCreate() {
      if (saving.value) return
      showCreate.value = false
    }

    const switchingId = ref<string | null>(null)
    const switchError = ref<string | null>(null)

    /** In die Organisation wechseln (Superadmin hat backendseitig OWNER-Zugriff) */
    async function openOrg(org: { organisationId: string; name?: string }) {
      switchingId.value = org.organisationId
      switchError.value = null
      try {
        await store.dispatch('organisation/LOAD', org.organisationId)
        // Kompletter Reload statt SPA-Navigation, damit alle Stores (Kurse,
        // Aufgaben, Zuweisungen …) frisch für die neue Organisation laden.
        window.location.href = '/'
      } catch (e: any) {
        switchError.value = `Organisation „${org.name || org.organisationId}" konnte nicht geöffnet werden.`
        switchingId.value = null
      }
    }

    function validEmail(v: string): boolean {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)
    }

    async function submitCreate() {
      formError.value = null
      if (!form.orgName.trim()) { formError.value = 'Bitte einen Organisationsnamen angeben.'; return }
      if (!form.adminName.trim()) { formError.value = 'Bitte den Namen des Admins angeben.'; return }
      if (!validEmail(form.adminEmail.trim())) { formError.value = 'Bitte eine gültige E-Mail-Adresse angeben.'; return }

      saving.value = true
      try {
        await store.dispatch('superAdmin/CREATE_ORG_WITH_ADMIN', {
          orgName: form.orgName.trim(),
          adminName: form.adminName.trim(),
          adminEmail: form.adminEmail.trim(),
        })
        successMsg.value = `Organisation „${form.orgName.trim()}" angelegt. Einladung an ${form.adminEmail.trim()} versendet.`
        showCreate.value = false
      } catch (e: any) {
        formError.value = 'Anlegen fehlgeschlagen. Existiert die E-Mail bereits?'
      } finally {
        saving.value = false
      }
    }

    onMounted(load)

    return {
      organisations, loading, error, successMsg,
      showCreate, saving, formError, form,
      openCreate, closeCreate, submitCreate,
      switchingId, switchError, openOrg,
    }
  },
})
